import { Component, OnInit } from '@angular/core';
import { LayoutService } from '@app/core/services/layout.service';
import { EconomyService, ShiftTypeItem } from '@app/services/economy.service';

@Component({
  selector: 'tt-shifts',
  templateUrl: './shifts.component.html',
  styleUrls: ['./shifts.component.css'],
  standalone: false,
})
export class ShiftsComponent implements OnInit {
    public shifts: ShiftTypeItem[] = [];
    public shiftId = '';
    public readonly tabletSize: MediaQueryList;

    constructor(private readonly economy: EconomyService, layout: LayoutService) {
        this.tabletSize = layout.getMediaQueries().tablet;
    }

    public async ngOnInit(): Promise<void> { await this.updateShifts(); }
    public async updateShifts(): Promise<void> { this.shifts = await this.economy.getShiftTypes(); }
    public openShift(item: ShiftTypeItem): void { this.shiftId = item.item_id; }
    public createShift(): void { this.shiftId = '0'; }
}
